export default __webpack_public_path__ + "aa3e3cecab71f437d3b5a0e721a3d5bf.png";